<template>
<!-- 专著预览 -->
  <div class="bookPreview">
    <p v-show="state" class="invalid">该页面为预览效果，短期内将会失效</p>
    <div v-if="state" class="content">
      <div class="lift">
        <p>
          <img src="@/assets/img/details/2.png" alt="">
          <span>收藏</span>
        </p>
        <p v-if="previewList.payUrl">
          <img src="@/assets/img/details/buy.png" alt="">
          <span>购买</span>
        </p>
        <p>
          <img src="@/assets/img/details/share.png" alt="">
          <span>分享</span>
        </p>
      </div>
      <div>
        <div class="centre">
          <div class="centre-top">
            <div class="img">
              <img v-lazy="`${$global.imgUrl}${previewList.cover}`" alt="">
            </div>
            <div>
              <ul>
                <li v-if="previewList.monographName" class="h" v-html="previewList.monographName">{{previewList.monographName}}</li>
                <li>
                  <span>作者：</span>
                  <span style="margin-right:10px" v-for="item in previewList.articleAuthors" :key="item.id">{{item.authorName}}</span>
                </li>
                <li v-if="previewList.translatorJson && previewList.translatorJson.length > 0" >
                  <span>译者：</span>
                  <span>{{previewList.translatorJson.toString()}}</span>
                </li>
                <li v-if="previewList.press">
                  出版单位: {{previewList.press}}
                </li>
                <li>
                  <span v-if="previewList.edition" style="margin-right:15px;">版次：{{previewList.edition}}</span>
                  <span v-if="previewList.pageNumber" style="margin-right:15px;">页数：{{previewList.pageNumber}}</span>
                  <span v-if="previewList.monographLenght" style="margin-right:15px;">字数：{{previewList.monographLenght}}</span>
                  <span v-if="previewList.isbn" style="margin-right:15px;">ISBN：{{previewList.isbn}}</span>
                </li>
                <li>
                  <span v-if="previewList.showPublishTime" style="margin-right:15px;">出版时间: {{previewList.showPublishTime}}</span>
                  <span v-if="previewList.classifyNumber">中图分类号：{{previewList.classifyNumber}}</span>              
                </li>
              </ul>
            </div>
          </div>
          <div v-if="previewList.artSummary" class="center-bottom">
            内容简介：{{previewList.artSummary}}
          </div>
        </div>
        <div class="centre">
          <span class="catalogue">目录</span>
          <p v-if="previewList.catalogue" v-html="previewList.catalogue"></p>
        </div>
      </div>
      <div>
        <div >
          <div class="right">
            <p class="right-1">发布者</p>
            <p class="right-2">
              <img v-lazy="`${$global.imgUrl}${user.headImg}`" alt="">
              <span>{{user.name}}</span>
            </p>
            <div class="right-3">
              <span class="wx">
                <span style="fontSize:18px;color:#ff7d14">0</span>
                <span>文献数</span>
              </span>
              <span class="zx">
                <span style="fontSize:18px;color:#ff7d14">0</span>
                <span>资讯数</span>
              </span>
            </div>
          </div>
          <div class="right2">
            <div class="h">相似文献</div>
            <div class="list">
              <ul>
                <li v-for="item in wenxian" :key="item.id">
                 <span v-html="item.title">{{item.title}}</span> 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="images">
      <img src="@/assets/img/details/urlDisabled.png" alt="">
      <div>临时链接已失效</div>
    </div>
  </div>
</template>

<script>
export default {
     name:'bookPreview',
    components: {

    },
    props: {

    },
    data() {
        return {
          previewList:{},
          user:{},
          wenxian:{},
          state:true
        };
    },
    computed: {

    },
    watch: {

    },
   async created() {
     await this.setPreview()
    },
    mounted() {

    },
    methods: {
      // 获取预览详情
          async setPreview(){
        const resp = await this.$apis.userServe.articlePreview({
        articleId: this.$route.query.articleId
        });
        if(resp.resultCode == 200 ) {
          this.previewList = resp.data.data
          this.getAuthor()
          this.getwenxian()
        }else{
          this.state = false
        }
      },
      // 获取发布者信息
      async getAuthor(){
        const resp = await this.$apis.recomendServe.getAuthor({
          userId:this.previewList.createUser,
          type:this.previewList.userType
        })
        if(resp.resultCode == 200){
          this.user = resp.content
        }
        console.log(resp)
      },
      // 获取最新资讯
      async getwenxian(){
        let obj = {
          title: encodeURI(this.previewList.monographName),
          pageNo:1,
          pageSize:5
        }
        const { data } = await this.$apis.recomendServe.getwenxian(obj)
          this.wenxian = data.list
          console.log(this.wenxian)
      }
    },
};
</script>

<style scoped lang="scss">
.bookPreview{
  .invalid{
    margin: 0 auto 50px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
  }
  .images{
    text-align: center;
    position: relative;
    top: 50px;
    margin-top: 50px;
    & img{
      margin-bottom: 50px;
    }
  }
  .content{
    display: flex;
    justify-content: center;
    .lift{
      margin-right: 40px;
      font-size: 13px;
      p{
        margin-bottom:44px;
        display: flex;
        flex-direction:column;
        text-align: center;
        
      }
      p img{
        margin-left: 16px;
        width: 28px;
        height: 28px;
      }
      p span{
          width: 60px !important;
      }
    }
    .centre{
      width: 905px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      padding: 25px 25px;
      margin-bottom: 10px;
      .centre-top{
        display: flex;
        font-size: 14px;
        color: #333;
        .img{
          img{
            width: 150px;
            height: 150px;
          }
        }
        & ul{
          margin-left: 10px;
        }
        ul li {
          line-height: 30px;
        }
        .h{
          color: #263d78;
          font-weight: bold;
          font-size: 30px;
          margin-bottom: 5px;
          line-height: 40px;
        }
      }
      .center-bottom{
        margin-top: 30px;
        line-height: 30px;
      }
      .catalogue{
        display: inline-block;
        color: #0b35c5;
        font-size: 20px;
        font-weight: bold;
        border-bottom: #0b35c5 4px solid;
        margin-bottom: 25px;
      }
    }
    .right{
      width: 270px;
      height: 250px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .right-1{
        margin: 25px 0 0 20px;
      }
      .right-2{
        text-align: center;
        img{
          width: 84px;
          height: 84px;
          border-radius: 50px;
        }
        span{
          display: block;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin-top: 15px;
        }
      }
      .right-3{
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        font-size: 12px;
        .wx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
        .zx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
      }
    }
    .right2{
      width: 270px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .h{
        font-size: 18px;
        color: #333;
        padding: 20px 25px;
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
      }
      .list{
        ul li{
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          padding-bottom: 20px;
          color: #666;
          border-bottom: 1px dashed #e8e8e8;
          font-size: 12px;
        }
        ul :nth-last-child(1){
          border-bottom: none;
        }
      }
    }
  }
}

</style>
